import { ImagesUrlPrefix, ThumbsSuffix } from 'lib/Constants';

import acura from '../static/img/brands/acura-202936.png';
import alfa from '../static/img/brands/alfa-1-202941.png';
import audi from '../static/img/brands/audi-2-202945.png';
import bmw from '../static/img/brands/bmw-5-202750.png';
import chevrolet from '../static/img/brands/chevrolet-4-202740.png';
import chrysler from '../static/img/brands/chrysler-202747.png';
import citroen from '../static/img/brands/citroen48.png';
import dacia from '../static/img/brands/dacia-202754.png';
import daihatsu from '../static/img/brands/daihatsu-2-202759.png';
import ferrari from '../static/img/brands/ferrari-4-202771.png';
import fiat from '../static/img/brands/fiat-1-202773.png';
import ford from '../static/img/brands/ford-1-202767.png';
import gmc from '../static/img/brands/gmc-202768.png';
import honda from '../static/img/brands/honda-3-202780.png';
import hummer from '../static/img/brands/hummer-202795.png';
import hyundai from '../static/img/brands/hyundai-6-202804.png';
import isuzu from '../static/img/brands/isuzu-2-202820.png';
import jaguar from '../static/img/brands/jaguar-3-202816.png';
import jeep from '../static/img/brands/jeep-59-202822.png';
import kia from '../static/img/brands/kia-202823.png';
import land from '../static/img/brands/land-5-202834.png';
import lexus from '../static/img/brands/lexus-202828.png';
import mazda from '../static/img/brands/mazda-1-202843.png';
import mercedes from '../static/img/brands/mercedes-8-202855.png';
import mg from '../static/img/brands/mg-202848.png';
import mini from '../static/img/brands/MINI48.png';
import mitsubishi from '../static/img/brands/mitsubishi-1-202851.png';
import nissan from '../static/img/brands/nissan-5-202859.png';
import opel from '../static/img/brands/opel-4-202864.png';
import peugeot from '../static/img/brands/peugeot-1-202867.png';
import porsche from '../static/img/brands/porsche-5-202881.png';
import renault from '../static/img/brands/renault48.png';
import rover from '../static/img/brands/rover-1-202888.png';
import saab from '../static/img/brands/saab-3-202896.png';
import seat from '../static/img/brands/Seat48.png';
import skoda from '../static/img/brands/skoda-1-202898.png';
import smart from '../static/img/brands/smart-48-202903.png';
import subaru from '../static/img/brands/subaru-2-202906.png';
import suzuki from '../static/img/brands/suzuki48.png';
import toyota from '../static/img/brands/toyota-1-202914.png';
import volkswagen from '../static/img/brands/volkswagen-52-202925.png';
import volvo from '../static/img/brands/volvo-202923.png';

import noImg from '../static/img/notAvailable.png';

const getImageUrl = (filename, folderNumber) =>
  `${ImagesUrlPrefix}/${folderNumber}/${filename}`;

const getThumbUrl = (filename, folderNumber) => {
  const thumbFilename = filename
    ? filename
        .split('.')
        .map((item, i, arr) =>
          i === arr.length - 1 ? `${ThumbsSuffix}.${item}` : item
        )
        .join('.')
    : '';
  return `${ImagesUrlPrefix}/${folderNumber}/${thumbFilename}`;
};

export { getImageUrl, getThumbUrl };

const getBrand = brand => {
  const brandsArray = [
    { img: acura, brand: 'acura' },
    { img: alfa, brand: 'alfa' },
    { img: audi, brand: 'audi' },
    { img: bmw, brand: 'bmw' },
    { img: chevrolet, brand: 'chevrolet' },
    { img: citroen, brand: 'citroËn' },
    { img: citroen, brand: 'citroen' },
    { img: chrysler, brand: 'chrysler' },
    { img: dacia, brand: 'dacia' },
    { img: daihatsu, brand: 'daihatsu' },
    { img: ferrari, brand: 'ferrari' },
    { img: fiat, brand: 'fiat' },
    { img: ford, brand: 'ford' },
    { img: gmc, brand: 'gmc' },
    { img: honda, brand: 'honda' },
    { img: hummer, brand: 'hummer' },
    { img: hyundai, brand: 'hyundai' },
    { img: isuzu, brand: 'isuzu' },
    { img: jaguar, brand: 'jaguar' },
    { img: jeep, brand: 'jeep' },
    { img: kia, brand: 'kia' },
    { img: land, brand: 'land' },
    { img: lexus, brand: 'lexus' },
    { img: mazda, brand: 'mazda' },
    { img: mercedes, brand: 'mercedes' },
    { img: mg, brand: 'mg' },
    { img: mini, brand: 'mini' },
    { img: mitsubishi, brand: 'mitsubishi' },
    { img: nissan, brand: 'nissan' },
    { img: opel, brand: 'opel' },
    { img: opel, brand: 'opel' },
    { img: peugeot, brand: 'peugeot' },
    { img: porsche, brand: 'porsche' },
    { img: renault, brand: 'renault' },
    { img: rover, brand: 'rover' },
    { img: saab, brand: 'saab' },
    { img: seat, brand: 'seat' },
    { img: skoda, brand: 'skoda' },
    { img: smart, brand: 'smart' },
    { img: subaru, brand: 'subaru' },
    { img: suzuki, brand: 'suzuki' },
    { img: toyota, brand: 'toyota' },
    { img: volkswagen, brand: 'volkswagen' },
    { img: volvo, brand: 'volvo' },
  ];

  let selectedBrand = brandsArray.find(
    x => brand.toLocaleLowerCase().indexOf(x.brand.toLocaleLowerCase()) > -1
  );

  return selectedBrand ? selectedBrand.img : noImg;
};

export { getBrand };
